import React from 'react';

interface ToggleSwitchProps {
  enabled?: boolean;
  onChange: (enabled: boolean) => void;
  locked?: boolean;
  label: string;
  description: string;
}

export const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  enabled = false,
  onChange,
  locked = false,
  label,
  description,
}) => {
  return (
    <div
      className="flex items-start justify-between py-4 border-b border-white/[0.06]"
      id={`toggle-row-${label.toLowerCase().replace(/\s+/g, '-')}`}
    >
      <div className="flex-1 pr-4 text-left">
        <div className="flex items-center gap-2">
          <span className="text-[11px] font-semibold text-white font-heading">
            {label}
          </span>
          {locked && <i className="fas fa-lock text-[9px] text-white/40" />}
        </div>
        <p className="text-[10px] text-white/60 mt-1 leading-relaxed">{description}</p>
      </div>
      <button
        type="button"
        onClick={() => !locked && onChange(!enabled)}
        disabled={locked}
        className={`relative w-11 h-6 rounded-full transition-colors duration-200 shrink-0 cursor-pointer ${
          locked 
            ? 'bg-white/10 opacity-60 cursor-not-allowed' 
            : enabled 
              ? 'bg-[#F26522]' 
              : 'bg-white/20 hover:bg-white/30'
        }`}
        id={`toggle-btn-${label.toLowerCase().replace(/\s+/g, '-')}`}
      >
        <div
          className={`absolute top-1 w-4 h-4 rounded-full bg-white transition-transform duration-200 ${
            enabled ? 'translate-x-6' : 'translate-x-1'
          }`}
        />
      </button>
    </div>
  );
};
